import z from 'zod';
import { scopedEntity, assetRef, zoneRef, anyGeometry, datetime, string, } from '../common';
export var BeaconType;
(function (BeaconType) {
    BeaconType["Default"] = "default";
    BeaconType["Tag"] = "tag";
})(BeaconType || (BeaconType = {}));
export const beaconState = z.object({
    lastSeenBy: assetRef.nullish(),
    lastSeenAt: datetime.nullish(),
    battery: z.number().nullish(),
});
export const beacon = z.object({
    ...scopedEntity.shape,
    codes: string.array(),
    rssiAddend: z.number().min(0),
    type: z.nativeEnum(BeaconType),
    state: beaconState.nullable(),
    asset: assetRef.nullish(),
    zone: zoneRef.nullish(),
    location: anyGeometry.nullish(),
});
